<template>
  <v-card>
    <v-card-title>カレンダー条件の指定</v-card-title>
    <v-card-text>
      <v-container>
        <v-form ref="form" v-model="valid">
          <v-row>
            <v-select
              :items="$store.state.colors"
              :background-color="returnData.values.colo"
              class="ma-2"
              v-model="returnData.values.color"
              label="予定のデフォルトカラー"
            ></v-select>
            <v-select
              :items="type"
              v-model="returnData.values.type"
              class="ma-2"
              label="デフォルトの月・週・日単位"
            ></v-select>
            <v-text-field
              class="d-inline ma-2"
              label="イベント名フォームID"
              v-model.number="returnData.values.display"
              :rules="[varidation.numonly]"
              required
            ></v-text-field>
          </v-row>
          <v-row>
            <v-text-field
              class="d-inline ma-2"
              label="開始日付フォームID"
              v-model.number="returnData.values.StartDay"
              :rules="[varidation.numonly]"
              required
            ></v-text-field>
            <v-text-field
              class="d-inline ma-2"
              label="開始時間フォームID"
              v-model.number="returnData.values.StartTime"
              :rules="[varidation.numonly]"
              required
            ></v-text-field>
            <v-text-field
              class="d-inline ma-2"
              label="終了日付フォームID"
              v-model.number="returnData.values.EndDay"
              :rules="[varidation.numonly]"
              required
            ></v-text-field>
            <v-text-field
              class="d-inline ma-2"
              label="終了時間フォームID"
              v-model.number="returnData.values.EndTime"
              :rules="[varidation.numonly]"
              required
            ></v-text-field>
          </v-row>
          <v-row>
            <v-col cols="4">
              <v-checkbox
                v-model="checkbox1"
                label="ユーザ名のレポートのみ表示"
              ></v-checkbox>
            </v-col>
            <v-col v-if="checkbox1">
              <v-text-field
                label="ユーザ名のフォームID"
                v-model.number="returnData.values.initFormID"
                :rules="[varidation.numonly]"
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4">
              <v-checkbox
                v-model="checkbox2"
                label="特手フォームによって色を変える"
              ></v-checkbox>
            </v-col>
            <v-col v-if="checkbox2">
              <v-text-field
                label="基準となるフォームID"
                v-model.number="returnData.values.colorBaseID"
                :rules="[varidation.numonly]"
              >
              </v-text-field>
            </v-col>
          </v-row>
        </v-form>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-col align="right">
        <v-btn :color="values.color + ' white--text'" @click="submit">OK</v-btn>
      </v-col>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  props: {
    values: Object,
  },
  data() {
    return {
      returnData: {
        values: this.values,
      },
      type: ["month", "week", "day"],
      //
      checkbox1: false,
      checkbox2: false,
      //バリデーション
      valid: true,
      varidation: {
        numonly: (value) => {
          return /^[0-9]*$/.test(value) || "数値のみ";
        },
      },
    };
  },
  mounted() {
    if (this.returnData.values.initFormID != null) {
      this.checkbox1 = true;
    }
    if (this.returnData.values.colorBaseID != null) {
      this.checkbox2 = true;
    }
  },
  methods: {
    submit() {
      //バリデーション
      if (this.$refs.form.validate()) {
        if (!this.checkbox1) {
          this.returnData.values.initFormID = null;
        }
        if (!this.checkbox2) {
          this.returnData.values.colorBaseID = null;
        }

        console.log(this.returnData.values);
        this.$emit("clickSubmit", this.returnData);
      }
    },
  },
};
</script>
